module.exports = __webpack_public_path__ + "media/svg-new/cloud-computing-f66d1bc0.svg";